import { SHOW_HIDE_MEMBERSHIP_CARD, SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS, SHOW_HIDE_MEMBERSHIP_CARD_ERROR, SHOW_HIDE_MEMBERSHIP_CARD_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ShowHideMembershipCard = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_HIDE_MEMBERSHIP_CARD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SHOW_HIDE_MEMBERSHIP_CARD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SHOW_HIDE_MEMBERSHIP_CARD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ShowHideMembershipCard;
